import { render, staticRenderFns } from "./development.vue?vue&type=template&id=5462bcac&scoped=true"
import script from "./development.vue?vue&type=script&lang=js"
export * from "./development.vue?vue&type=script&lang=js"
import style0 from "./development.vue?vue&type=style&index=0&id=5462bcac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462bcac",
  null
  
)

export default component.exports